module.exports = __webpack_public_path__ + "public/images/icon-telegram-grey.32e6a5205d5a69c80106bfd1383ac241.svg";